(() => {
  const init = () => {
    const modal = document.getElementById('AogeoInquiryModal');
    if (!modal || modal.dataset.bound === 'true') return;
    modal.dataset.bound = 'true';

    const form = modal.querySelector('#AogeoInquiryForm');
    const title = modal.querySelector('[data-aogeo-inquiry-title]');
    const subtitle = modal.querySelector('[data-aogeo-inquiry-subtitle]');
    const contextNode = modal.querySelector('[data-aogeo-inquiry-context]');
    const submit = modal.querySelector('[data-aogeo-inquiry-submit]');
    const messageLabel = modal.querySelector('[data-aogeo-message-label]');
    const message = modal.querySelector('textarea[name="contact[body]"]');
    const fields = {};
    modal.querySelectorAll('[data-aogeo-field]').forEach((field) => {
      fields[field.dataset.aogeoField] = field;
    });

    let lastTrigger = null;
    const labels = {
      quote: 'Project quotation',
      solution: 'Application and process evaluation',
      sample: 'Sample testing',
      case: 'Similar project consultation',
      support: 'Technical support'
    };

    const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

    const classify = (trigger) => {
      const explicit = trigger.dataset.aogeoInquiry;
      if (explicit && labels[explicit]) return explicit;
      if (trigger.hasAttribute('data-aogeo-inquiry-skip')) return null;

      const text = cleanText(trigger.textContent);
      const href = trigger.getAttribute('href') || '';
      if (/^(mailto:|tel:|sms:|https?:\/\/(?:wa\.me|api\.whatsapp\.com))/i.test(href)) return null;

      const quoteRoute = /\/pages\/request-a-quote(?:[/?#]|$)/i.test(href);
      const contactRoute = /\/pages\/contact(?:[/?#]|$)/i.test(href);
      const isButton = trigger.tagName === 'BUTTON';
      if (!quoteRoute && !contactRoute && !isButton) return null;

      if (/(提交支持|提交具体问题|售后协助|支持请求|故障支持|submit support|service request|submit ticket|technical support request|after-sales assistance)/i.test(text)) return 'support';
      if (/(申请样品|提交样品|免费样品测试|样品测试|申请测试|request sample|sample test request|sample testing|request test)/i.test(text)) return 'sample';
      if (/(类似项目|提交项目资料|咨询案例|similar project|project materials)/i.test(text)) return 'case';
      if (/(应用评估|工艺评估|方案评估|发起项目评估|发起应用评估|application evaluation|process evaluation|solution review)/i.test(text)) return 'solution';

      if (contactRoute && !/(联系奥剑|联系销售|联系工程师|contact aogeo|contact sales|contact engineer)/i.test(text)) return null;
      if (isButton && !quoteRoute && !contactRoute && !/(报价|询价|项目咨询|提交需求|填写需求|获取方案|联系销售|get a quote|request quote|project consultation|submit project|contact sales)/i.test(text)) return null;

      if (/after-sales-technical-support|resources-faq/i.test(window.location.pathname)) return 'support';
      return 'quote';
    };

    const setMode = (intent) => {
      const support = intent === 'support';
      modal.querySelectorAll('[data-aogeo-sales-field]').forEach((group) => {
        group.hidden = support;
        group.querySelectorAll('input, select, textarea').forEach((field) => {
          field.disabled = support;
        });
      });
      modal.querySelectorAll('[data-aogeo-support-field]').forEach((group) => {
        group.hidden = !support;
        group.querySelectorAll('input, select, textarea').forEach((field) => {
          field.disabled = !support;
        });
      });

      const titleKey = intent + 'Title';
      if (title) title.textContent = modal.dataset[titleKey] || modal.dataset.quoteTitle;
      if (subtitle) subtitle.textContent = support ? modal.dataset.supportSubtitle : modal.dataset.salesSubtitle;
      if (submit) submit.textContent = support ? modal.dataset.supportSubmit : modal.dataset.salesSubmit;
      if (messageLabel) messageLabel.firstChild.textContent = (support ? modal.dataset.supportMessageLabel : modal.dataset.salesMessageLabel) + ' ';
      if (message) message.placeholder = support ? modal.dataset.supportPlaceholder : modal.dataset.salesPlaceholder;
      if (fields.type) fields.type.value = labels[intent] || labels.quote;
    };

    const openModal = (intent, trigger) => {
      lastTrigger = trigger || null;
      setMode(intent);

      const heading = cleanText(document.querySelector('main h1')?.textContent || document.querySelector('h1')?.textContent || document.title);
      let triggerText = cleanText(trigger?.textContent);
      let productContext = heading;
      const href = trigger?.getAttribute('href') || '';
      try {
        const target = new URL(href, window.location.origin);
        const product = target.searchParams.get('product');
        if (product) productContext = heading || product;
      } catch {}

      if (contextNode) contextNode.textContent = productContext || document.title;
      if (fields.source_page) fields.source_page.value = document.title;
      if (fields.source_url) fields.source_url.value = window.location.href;
      if (fields.source_trigger) fields.source_trigger.value = triggerText;
      if (fields.language) fields.language.value = document.documentElement.lang || '';
      if (fields.context) fields.context.value = productContext;

      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
      document.documentElement.classList.add('aogeo-inquiry-open');
      modal.dispatchEvent(new CustomEvent('aogeo:inquiry-open', { bubbles: true, detail: { form_type: intent } }));
      window.requestAnimationFrame(() => {
        modal.querySelector('input:not([type="hidden"]):not([disabled])')?.focus();
      });
    };

    const closeModal = () => {
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
      document.documentElement.classList.remove('aogeo-inquiry-open');
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('a, button, [role="button"]');
      if (!trigger || modal.contains(trigger)) return;
      const intent = classify(trigger);
      if (!intent) return;
      event.preventDefault();
      openModal(intent, trigger);
    }, true);

    modal.querySelectorAll('[data-aogeo-inquiry-close]').forEach((button) => {
      button.addEventListener('click', closeModal);
    });
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
    modal.addEventListener('close', () => {
      document.documentElement.classList.remove('aogeo-inquiry-open');
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    });

    if (modal.querySelector('[data-aogeo-inquiry-success], [data-aogeo-inquiry-errors]')) {
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
      document.documentElement.classList.add('aogeo-inquiry-open');
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
